import { doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../firebase";

/**
 * Corrige les anciens 'opportunityType' dans les factures :
 * remplace les valeurs contenant ':::' par le vrai nom du type d'opportunité correspondant.
 */
export async function cleanupInvoices() {
  const docRef = doc(db, "prospects", "foodinnovCompanies");
  const docSnap = await getDoc(docRef);
  if (!docSnap.exists()) {
    console.error("Document foodinnovCompanies non trouvé");
    return;
  }
  const data = docSnap.data();
  let corrections = 0;
  for (const companyId in data) {
    const companyData = data[companyId];
    if (!companyData.invoices || !Array.isArray(companyData.invoices)) continue;
    if (!companyData.opportunities || !Array.isArray(companyData.opportunities)) continue;
    let updated = false;
    const newInvoices = companyData.invoices.map((invoice: any) => {
      if (typeof invoice.opportunityType === "string" && invoice.opportunityType.includes(":::") ) {
        // Extraire l'index
        const parts = invoice.opportunityType.split(":::");
        const idx = parseInt(parts[1], 10);
        const opp = companyData.opportunities[idx];
        if (opp && opp.type) {
          corrections++;
          updated = true;
          return { ...invoice, opportunityType: opp.type };
        }
      }
      return invoice;
    });
    if (updated) {
      await updateDoc(docRef, {
        [`${companyId}.invoices`]: newInvoices
      });
      console.log(`Factures corrigées pour la société ${companyId}`);
    }
  }
  if (corrections === 0) {
    console.log("Aucune correction nécessaire.");
  } else {
    console.log(`Corrections effectuées sur ${corrections} facture(s).`);
  }
} 